import React from "react";
import {LinkProps, RouteProps} from "react-router-dom";
import Login from "../pages/login/Login";
import Registration from "../pages/registration/Registration";
import Main from "../pages/main/Main";
import Testing from "../pages/testing/Testing";
import Positions from "../pages/positions/Positions";
import Ratings from "../pages/ratings/Ratings";
import MainTitle from "../pages/mainTitle/MainTitle";
import Strategies from "../pages/strategies/Strategies";
import SimulatedTransaction from "../pages/simulatedTransaction/SimulatedTransaction";
import InvestingTip from "../pages/investingTip/InvestingTip";
import EmailParsing from "../pages/emailParsing/EmailParsing";

export enum AppRoutes {
  MAIN_TITLE = 'mainTitle',
  LOGIN = 'login',
  REGISTRATION = 'registration',
  MAIN = 'main',
  STRATEGIES = 'strategies',
  POSITIONS = 'positions',
  RATINGS = 'ratings',
  TESTING = 'testing',
  SIMULATED_TRANSACTION = 'simulatedTransaction',
  INVESTING_TIP = 'investingTip',
  EMAIL_PARSING = 'emailParsing',
}

export const RoutePath: Record<AppRoutes, string> = {
  [AppRoutes.MAIN_TITLE]: '/',
  [AppRoutes.LOGIN]: '/login',
  [AppRoutes.REGISTRATION]: '/registration',
  [AppRoutes.MAIN]: '/main',
  [AppRoutes.STRATEGIES]: '/strategies',
  [AppRoutes.POSITIONS]: '/positions',
  [AppRoutes.RATINGS]: '/ratings',
  [AppRoutes.TESTING]: '/testing',
  [AppRoutes.SIMULATED_TRANSACTION]: '/simulated-transaction',
  [AppRoutes.INVESTING_TIP]: '/investing-tip',
  [AppRoutes.EMAIL_PARSING]: '/email-parsing',
}

export const RouteLabel: Record<AppRoutes, string> = {
  [AppRoutes.MAIN_TITLE]: 'MenuMainTitle',
  [AppRoutes.LOGIN]: 'MenuLogin',
  [AppRoutes.REGISTRATION]: 'MenuRegistration',
  [AppRoutes.MAIN]: 'MenuMain',
  [AppRoutes.STRATEGIES]: 'MenuStrategies',
  [AppRoutes.POSITIONS]: 'MenuPositions',
  [AppRoutes.RATINGS]: 'MenuRatings',
  [AppRoutes.TESTING]: 'MenuTesting',
  [AppRoutes.SIMULATED_TRANSACTION]: 'MenuSimulatedTransaction',
  [AppRoutes.INVESTING_TIP]: 'MenuInvestingTip',
  [AppRoutes.EMAIL_PARSING]: 'MenuEmailParsing',
}

export const routeConfig: Record<AppRoutes, { routeProps: RouteProps, forAuth: boolean }> = {
  [AppRoutes.MAIN_TITLE]: {
    routeProps: {
      path: RoutePath[AppRoutes.MAIN_TITLE],
      element: <MainTitle/>,
      children: RouteLabel[AppRoutes.MAIN_TITLE]
    },
    forAuth: true
  },
  [AppRoutes.LOGIN]: {
    routeProps: {
      path: RoutePath[AppRoutes.LOGIN],
      element: <Login/>,
      children: RouteLabel[AppRoutes.LOGIN]
    },
    forAuth: false
  },
  [AppRoutes.REGISTRATION]: {
    routeProps: {
      path: RoutePath[AppRoutes.REGISTRATION],
      element: <Registration/>,
      children: RouteLabel[AppRoutes.REGISTRATION]
    },
    forAuth: false
  },
  [AppRoutes.MAIN]: {
    routeProps: {
      path: RoutePath[AppRoutes.MAIN],
      element: <Main/>,
      children: RouteLabel[AppRoutes.MAIN]
    },
    forAuth: true
  },
  [AppRoutes.STRATEGIES]: {
    routeProps: {
      path: RoutePath[AppRoutes.STRATEGIES],
      element: <Strategies/>,
      children: RouteLabel[AppRoutes.STRATEGIES]
    },
    forAuth: true
  },
  [AppRoutes.POSITIONS]: {
    routeProps: {
      path: RoutePath[AppRoutes.POSITIONS],
      element: <Positions/>,
      children: RouteLabel[AppRoutes.POSITIONS]
    },
    forAuth: true
  },
  [AppRoutes.RATINGS]: {
    routeProps: {
      path: RoutePath[AppRoutes.RATINGS],
      element: <Ratings/>,
      children: RouteLabel[AppRoutes.RATINGS]
    },
    forAuth: true
  },
  [AppRoutes.TESTING]: {
    routeProps: {
      path: RoutePath[AppRoutes.TESTING],
      element: <Testing/>,
      children: RouteLabel[AppRoutes.TESTING]
    },
    forAuth: true
  },
  [AppRoutes.SIMULATED_TRANSACTION]: {
    routeProps: {
      path: RoutePath[AppRoutes.SIMULATED_TRANSACTION],
      element: <SimulatedTransaction/>,
      children: RouteLabel[AppRoutes.SIMULATED_TRANSACTION]
    },
    forAuth: true
  },
  [AppRoutes.INVESTING_TIP]: {
    routeProps: {
      path: RoutePath[AppRoutes.INVESTING_TIP],
      element: <InvestingTip/>,
      children: RouteLabel[AppRoutes.INVESTING_TIP]
    },
    forAuth: true
  },
  [AppRoutes.EMAIL_PARSING]: {
    routeProps: {
      path: RoutePath[AppRoutes.EMAIL_PARSING],
      element: <EmailParsing/>,
      children: RouteLabel[AppRoutes.EMAIL_PARSING]
    },
    forAuth: true
  },
}
